import store from '@/store';

export default [
  {
    key: 'actions',
    sortable: false,
    visible: true
  },
  {
    key: 'status',
    sortable: true,
    visible: true
  },
  {
    key: 'sale_type',
    sortable: true,
    visible: true
  },
  {
    key: 'transaction_type',
    sortable: true,
    visible: true
  },
  {
    key: 'primary_agent',
    sortable: true,
    visible: true
  },
  {
    key: 'full_address',
    label: 'Address',
    sortable: false,
    visible: true
  },
  {
    key: 'client_name',
    sortable: false,
    visible: false
  },
  {
    key: 'client_phone',
    sortable: false,
    visible: false
  },
  {
    key: 'client_email',
    sortable: false,
    visible: false
  },
  {
    key: 'units',
    label: 'Unit Goal',
    sortable: true,
    visible: true
  },
  {
    key: 'contingent_sale',
    sortable: true,
    visible: true
  },
  {
    key: 'contract_date',
    sortable: true,
    visible: true
  },
  {
    key: 'projected_close',
    label: 'Projected Close',
    sortable: true,
    visible: true
  },
  {
    key: 'close_date',
    label: 'Close Date',
    sortable: true,
    visible: true
  },
  {
    key: 'sale_price',
    sortable: true,
    visible: true
  },
  {
    key: 'amount',
    label: 'Commission %/Flat Rate',
    sortable: true,
    visible: false
  },
  {
    key: 'gross_commission',
    sortable: true,
    visible: store.getters['roles/admin']
  },
  {
    key: 'transaction_fee',
    sortable: true,
    visible: false
  },
  {
    key: 'net_commission',
    label: 'Company Net Commission', 
    sortable: true,
    visible: false
  },
  {
    key: 'members',
    label: 'Team',
    sortable: false,
    visible: store.getters['roles/admin']
  },
  {
    key: 'other_cos',
    label: 'Other COS',
    sortable: true,
    visible: false
  },
  {
    key: 'cos_details',
    label: 'COS Details',
    sortable: true,
    visible: false
  },
  {
    key: 'gross_profit',
    sortable: true,
    visible: true
  },
  {
    key: 'primary_source',
    label: 'Source',
    sortable: true,
    visible: true
  },
  {
    key: 'mortgage_company',
    sortable: true,
    visible: false
  },
  {
    key: 'loan_officer',
    sortable: true,
    visible: false
  },
  {
    key: 'title_company',
    sortable: true,
    visible: false
  },
  {
    key: 'law_firm',
    sortable: true,
    visible: false
  },
  {
    key: 'escrow_officer',
    sortable: true,
    visible: false
  },
  {
    key: 'inspection_company',
    sortable: true,
    visible: false
  },
  {
    key: 'insurance_company',
    sortable: true,
    visible: false
  },
  
];